import { useSupplyPointsQuery } from '@/src/api/kapi/use-supply-points-query';
import { Loadable } from '@/src/types/utils';
import {
  areComplexSupplies,
  hasAtLeastOneActiveSupply,
} from '@/src/utils/supplyPoints';

type UsageWidgetVisibility = Loadable<{ showUsageWidget: boolean }>;

export const useUsageWidgetVisibility = (): UsageWidgetVisibility => {
  const { data, isLoading, isError, error } = useSupplyPointsQuery();

  if (isLoading) {
    return {
      status: 'loading',
      isError: false,
      isLoading: true,
    };
  }

  if (isError || !data)
    return {
      status: 'error',
      isError: true,
      isLoading: false,
      error: error instanceof Error ? error : new Error('Supply points error'),
    };

  const hasActiveSupplies = hasAtLeastOneActiveSupply(
    data?.account?.accountSupplyPoints,
  );

  // Hide these components for complex supplies for now.
  const hasComplexSupplies = areComplexSupplies(
    data?.account?.accountSupplyPoints,
  );

  return {
    status: 'success',
    isError: false,
    isLoading: false,
    data: {
      showUsageWidget: hasActiveSupplies && !hasComplexSupplies,
    },
  };
};
